<template>
  <modal
    @close="doCancel"
    v-if="showModal"
    :width="'620px'"
    :theme="'light'"
  >
    <div slot="header" class="modal-header">
      {{ title }}
    </div>
    <div slot="body" class="body">
      {{ message }}
    </div>
    <div slot="footer" class="footer">
      <v-button
        :on-click="doCancel"
        class="cancel-button"
      >
        <span>{{ textCancel() }}</span>
      </v-button>
      <v-button
        :on-click="validate"
        class="confirm-button"
        data-cy="modal-confirm-button"
      >
        <span>{{ textConfirm() }}</span>
      </v-button>
    </div>
  </modal>
</template>
<script>
import Modal from '@/components/shared/Modal'
import VButton from '@/components/shared/VButton'

export default {
  name: 'RateSessionModal',
  components: { Modal, VButton },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    cancel: {
      type: String,
      required: false,
      default: function () { return this.$t('shared.modalConfirm.cancel') }
    },
    confirm: {
      type: String,
      required: false,
      default: function () { return this.$t('shared.modalConfirm.confirm') }
    }
  },
  methods: {
    validate () {
      this.$emit('confirm')
    },
    doCancel () {
      this.$emit('close')
    },
    textCancel () {
      return this.$options.propsData.cancel ? this.$options.propsData.cancel : this.$t('shared.modalConfirm.cancel')
    },
    textConfirm() {
      return this.$options.propsData.confirm ? this.$options.propsData.confirm : this.$t('shared.modalConfirm.confirm')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .body {
    color: $black-color;
    display: flex;
    margin: 1rem;
  }
  .footer {
    display: flex;
    box-shadow: inset 0 1px 0 0 #d8d8d8;
    justify-content: flex-end;
    padding: 10px 24px;

    .cancel-button {
      margin: 0 1rem;
      background-color: white;
      color: $primary-color;
      font-weight: 600;
      font-size: 14px;
      white-space: nowrap;
      border: thin solid $primary-color;
      padding: 0 20px;

      &:hover {
        color: white;
        background-color: $primary-color;
      }
    }

    .confirm-button {
      padding: 0 20px;
    }
  }
</style>
